import { useMemo } from 'react';

import { sha256 } from 'js-sha256';

import { NLPSearchJSONResultFormat, NLPSearchResultFormat } from '../../../ai-answer-dialog/types';
import { getTypedJSONResultDataAssistanceService } from '../../../ai-answer-dialog/utils/getTypedJSONResultData';

type GetCardTypeParams = {
	isReadingAids: boolean;
	answerFormat: NLPSearchResultFormat | null;
	parsedType: NLPSearchJSONResultFormat | null;
};

type getCardTypeReturn = 'definition' | 'people' | 'work' | 'SAIN';

export const getCardType = ({
	isReadingAids,
	answerFormat,
	parsedType,
}: GetCardTypeParams): getCardTypeReturn => {
	if (isReadingAids) {
		return 'definition';
	}

	if (answerFormat === NLPSearchResultFormat.JSON && parsedType === NLPSearchJSONResultFormat.WHO) {
		return 'people';
	}

	if (
		answerFormat === NLPSearchResultFormat.JSON &&
		parsedType === NLPSearchJSONResultFormat.WORK
	) {
		return 'work';
	}

	return 'SAIN';
};

type GetParsedTypeParams = {
	answerFormat: NLPSearchResultFormat | null;
	answerString: string;
};

export const getParsedType = ({
	answerFormat,
	answerString,
}: GetParsedTypeParams): NLPSearchJSONResultFormat | undefined => {
	if (answerFormat !== NLPSearchResultFormat.JSON) {
		return undefined;
	}

	return getTypedJSONResultDataAssistanceService(answerString).parsedType;
};

export const useSessionId = ({
	userId,
	cloudId,
	source,
}: {
	userId: string;
	cloudId: string;
	source: string;
}): string => {
	return useMemo(
		() => sha256(`${userId}-${cloudId}-${Date.now().toString()}-${source}`),
		[userId, cloudId, source],
	);
};
